import { render, staticRenderFns } from "./configjrmCustom.vue?vue&type=template&id=50df00ea&scoped=true&"
import script from "./configjrmCustom.vue?vue&type=script&lang=js&"
export * from "./configjrmCustom.vue?vue&type=script&lang=js&"
import style0 from "./configjrmCustom.vue?vue&type=style&index=0&id=50df00ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50df00ea",
  null
  
)

component.options.__file = "configjrmCustom.vue"
export default component.exports